import { getApiBaseUrl, Hair_API_PREFIX } from './apiConfig';
import { fetchWithTimeout } from './fetchWithTimeout';

export const ANALYZE_HAIR_PATH = `${Hair_API_PREFIX}/analyze-hair-new`;

function getBaseUrl() {
  const raw = getApiBaseUrl();
  return (raw || '').replace(/\/$/, '');
}

export function buildHairAnalysisApiUrl(path) {
  const base = getBaseUrl();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
}

/**
 * Run hair analysis on the captured images.
 * 
 * @param {object} params
 * @param {object} params.hairCaptures - { crown, left, magnified_scalp? } base64 images
 * @param {string} params.hairType - "Straight", "Wavy", etc.
 * @param {string} [params.sessionId]
 * @param {number|null} [params.age]
 * @param {string|null} [params.appSessionToken]
 */
export async function detectHair({ hairCaptures, hairType, sessionId, age, appSessionToken, name, mobileNumber, email }) {
  const url = buildHairAnalysisApiUrl(ANALYZE_HAIR_PATH);
  const body = {
    hair_captures: hairCaptures,
    hair_type: hairType,
    session_id: sessionId ?? null,
    age: age ?? null,
    app_session_token: appSessionToken ?? null,
    name: name ?? null,
    mobile_number: mobileNumber ?? null,
    email: email ?? null,
  };

  const response = await fetchWithTimeout(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    // Slow machines + large base64 payloads can take several minutes.
    // This timeout must be >= end-to-end request time (upload + JSON parse + model inference).
    timeoutMs: 900000, // 15 minutes — Qwen VL can take minutes per view locally

  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || response.statusText || 'Hair analysis request failed');
    error.status = response.status;
    error.apiResponse = data;
    throw error;
  }
  return data;
}
